@if (!loading && siteId) {
    <div
        class="clock-section"
        [class.clocked-in]="isClockedIn"
        (click)="onToggleClock()"
        role="button"
        [attr.aria-label]="isClockedIn ? 'Clock Out' : 'Clock In'">

        <!-- Icon with pulsing dot when clocked in -->
        <div class="clock-icon-wrapper">
            <i class="fa-solid nav-icon"
                [ngClass]="isClockedIn ? 'fa-right-from-bracket' : 'fa-right-to-bracket'">
            </i>
            @if (isClockedIn) {
                <span class="pulse-dot"></span>
            }
        </div>

        <!-- Label area -->
        <span class="clock-label text-truncate">
            @if (isClockedIn) {
                <span class="clock-text">Clock Out</span>
                <span class="elapsed-time">{{ elapsedDisplay }}</span>
            } @else {
                <span class="clock-text">Clock In</span>
            }
        </span>
    </div>
}
